import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { SidebarComponent } from '@app/layouts/post-auth-layout/sidebar/sidebar.component';
import { HeaderComponent } from '@app/layouts/post-auth-layout/header/header.component';
import { Store } from '@ngrx/store';
import { selectedTimeSeriesItems } from '@app/ngrx/time-series/time-series.selector';
import { loadTimeseriesInfoApis } from '@app/ngrx/time-series/time-series.actions';
import { loadCoreApis } from '@app/ngrx/core-api/coreapi.actions';
import { take } from 'rxjs/operators';
import { AppModule } from '@app/enums';
import { ChatPopupComponent } from '@app/post-auth/common-components/chat-popup/chat-popup.component';

@Component({
  selector: 'app-mainlayout',
  imports: [
    HeaderComponent,
    SidebarComponent,
    NzLayoutModule,
    RouterOutlet,
    ChatPopupComponent,
  ],
  templateUrl: './mainlayout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./mainlayout.component.scss'],
})
export class MainlayoutComponent {
  isCollapsed = false;
  router = inject(Router);
  sidebarWidth = 0;
  store = inject(Store);
  isInsuranceActive = false;

  ngOnInit() {
    const moduleName: any = this.moduleName;
    this.isInsuranceActive = AppModule.INSURANCE === moduleName;
    const eligiblityMap = this.moduleConfigMap.get(moduleName)?.eligibilityMap ?? {};
    this.store
      .select(selectedTimeSeriesItems)
      .pipe(take(1))
      .subscribe((data: any) => {
        const allAvailableKeys = Object.keys(data);
        const check =
          allAvailableKeys.length > 0
            ? allAvailableKeys.every((item) => eligiblityMap.hasOwnProperty(item))
            : false;
        if (!check) {
          this.store.dispatch(loadTimeseriesInfoApis({ module: moduleName }));
          this.store.dispatch(loadCoreApis());
        }
      });
  }

  get moduleName() {
    const url = this.router.url;
    let moduleName: string = AppModule.ETF;
    if (url.includes(AppModule.ETF)) {
      moduleName = AppModule.ETF;
    } else if (url.includes(AppModule.INSURANCE)) {
      moduleName = AppModule.INSURANCE;
    } else if (url.includes(AppModule.OCIO)) {
      moduleName = AppModule.OCIO;
    } else if (url.includes(AppModule.OSMA)) {
      moduleName = AppModule.OSMA;
    }

    return moduleName;
  }

  private moduleConfigMap = new Map([
    [
      AppModule.ETF,
      {
        eligibilityMap: {
          instrumentTsInfo: true,
          portfolioTsInfo: true,
        },
      },
    ],
    [
      AppModule.INSURANCE,
      {
        eligibilityMap: {
          assetsTsInfo: true,
          liabilitiesTsInfo: true,
          instrumentTsInfo: true,
        },
      },
    ],
    [
      AppModule.OCIO,
      {
        eligibilityMap: {
          assetsTsInfo: true,
          liabilitiesTsInfo: true,
          instrumentTsInfo: true,
        },
      },
    ],
    [
      AppModule.OSMA,
      {
        eligibilityMap: {
          assetsTsInfo: true,
          liabilitiesTsInfo: true,
          instrumentTsInfo: true,
        },
      },
    ],
  ]);

  toggleSidebar(): void {
    this.isCollapsed = !this.isCollapsed;
    this.sidebarWidth = window.innerWidth < 768 ? 0 : 60;
  }
}
